<template>
  <div class="main-container">
    <b-card>
      <div v-if="adDetails">
        <div class="d-flex align-items-center justify-content-between">
          <h1>بازبینی آگهی {{ adDetails.title }}</h1>
          <div>
            <b-button variant="outline-success mr-1" @click="confirmAd"
              >تایید</b-button
            >
            <b-button variant="outline-danger mr-1" @click="rejectAd"
              >رد</b-button
            >
          </div>
        </div>

        <small class="text-secondary">{{
          timeAgo(adDetails.createDate)
        }}</small>
        <br />
        <small class="text-secondary">
          {{ adStatuses[adDetails.status] }}</small
        >
        <b-list-group class="mt-2">
          <b-list-group-item>
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">دسته بندی</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.categoryTitle }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item class="flex-column align-items-start">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">عنوان</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.title }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.channel"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">شبکه</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.channel }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.programName"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">نام برنامه</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.programName }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.time"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">ساعت پخش</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.time }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.time"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">مدت زمان پخش</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.playTime }} ثانیه
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.chargeType"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">واحد پول</h5>
            </div>
            <b-card-text class="mb-1">
              {{ chargeType[adDetails.chargeType] }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.chargeTypePrice"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">مقدار شارژ اکانت</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.chargeTypePrice }}
              {{ chargeType[adDetails.chargeType] }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.havePromotion"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">پروموشن</h5>
            </div>
            <b-card-text class="mb-1"> دارد </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.promotionPrice"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">هزینه پروموشن</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.promotionPrice }}
              {{ chargeType[adDetails.chargeType] }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.accountManager"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">مدریریت اکانت</h5>
            </div>
            <b-card-text class="mb-1"> دارد </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.accountAccess"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">دسترسی مستقیم</h5>
            </div>
            <b-card-text class="mb-1"> دارد </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.height"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">ارتفاع</h5>
            </div>
            <b-card-text class="mb-1"> {{ adDetails.height }} متر </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.width"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">عرض</h5>
            </div>
            <b-card-text class="mb-1"> {{ adDetails.width }} متر </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.stateName"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">استان</h5>
            </div>
            <b-card-text class="mb-1"> {{ adDetails.stateName }} </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.cityName"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">شهر</h5>
            </div>
            <b-card-text class="mb-1"> {{ adDetails.cityName }} </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.physicalCategoryTitle"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">موقعیت</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.physicalCategoryTitle }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.propertyTitle"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">نوع موقعیت</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.propertyTitle }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.guildName"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">صنف</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.guildName }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.price || adDetails.adaptive"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">قیمت</h5>
            </div>
            <b-card-text class="mb-1">
              <template v-if="adDetails.price">
                {{ Intl.NumberFormat("fa-IR").format(adDetails.price) }} تومان
              </template>
              <template v-else-if="adDetails.adaptive">توافقی</template>
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.address"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">آدرس</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.address }}
            </b-card-text>
          </b-list-group-item>
          <b-list-group-item
            class="flex-column align-items-start"
            v-if="adDetails.description"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">توضیحات</h5>
            </div>
            <b-card-text class="mb-1">
              {{ adDetails.description }}
            </b-card-text>
          </b-list-group-item>
        </b-list-group>
        <div class="row my-2">
          <img
            style="max-height: 300px"
            v-for="(media, index) in adDetails.medias.filter(
              (item) => item.priority == 2 || item.priority == 1
            )"
            :key="index"
            class="col-md-4"
            :src="
              'https://api.faradidar.com/media/gallery/adsmedia/' + media.base64
            "
            alt=""
          />
          <video
            v-if="adVideo"
            class="my-2 col-md-4"
            controls
            :src="adVideo"
          ></video>
        </div>
      </div>
      <map-container
        v-if="latitude && longitude"
        :latitude="latitude"
        :longitude="longitude"
        :markerGeoLoc="defaultGeoLoc"
      ></map-container>
    </b-card>
  </div>
</template>
<script>
import GetAnAdRequest from "@/libs/Api/MainFlatTable/GetAnAdRequest";
import MapContainer from "./MapContainer.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { getUserData } from "@/auth/utils";
import axios from "axios";

import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BListGroup,
  BCarousel,
  BCarouselSlide,
  BListGroupItem,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
export default {
  title: "بازبینی آگهی - پنل ادمین فرادیدار",

  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BCarousel,
    BCarouselSlide,
    BListGroup,
    BListGroupItem,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BTabs,
    BTab,
    BFormGroup,
    BFormTextarea,
    BBadge,
    BForm,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    MapContainer,
  },
  created() {
    axios.defaults.headers.common["Authorization"] = getUserData().data.token;
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    this.getAd();
  },
  // mounted() {
  //   // Vue.nextTick(() => {
  //   this.map = L.map("mapcontainer").setView([35.76037495, 51.44600272], 14);
  //   L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
  //     maxZoom: 19,
  //     attribution: "© OpenStreetMap",
  //   }).addTo(this.map);

  //   // Leaflet has a known issue with wrong marker address
  //   // This section is their provided solution for fixing the issue
  //   // Please don't touch it or marker won't be shown on the map
  //   delete L.Icon.Default.prototype._getIconUrl;
  //   L.Icon.Default.mergeOptions({
  //     iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  //     iconUrl: require("leaflet/dist/images/marker-icon.png"),
  //     shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  //   });
  //   // Solution ends here
  //   L.marker([35.76037495, 51.44600272]).addTo(this.map);
  //   // });
  // },
  data() {
    return {
      defaultGeoLoc: null,
      latitude: null,
      longitude: null,
      adDetails: null,
      adStatuses: {
        1: "در انتظار تایید",
        2: "تایید شده",
        3: "رد شده",
      },
      chargeType: {
        1: "درهم",
        2: "دلار",
        3: "لیر",
        4: "یورو",
        5: "پوند",
      },
    };
  },
  methods: {
    async getAd() {
      let _this = this;
      let getAnAdRequest = new GetAnAdRequest(_this);
      getAnAdRequest.setId(_this.$route.params.slug, _this.$route.params.id);
      await getAnAdRequest.fetch(
        function (content) {
          _this.adDetails = content;
          _this.latitude = content.latitude;
          _this.longitude = content.longitude;
          _this.markerGeoLoc = [content.latitude, content.longitude];
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async rejectAd() {
      try {
        const response = await axios.post(
          "https://api.faradidar.com/api/MainFlatTable/ChangeAdsStatus",
          null,
          {
            params: {
              status: 3,
              objectId: this.$route.params.id,
              slug: this.$route.params.slug,
            },
          }
        );
        this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `عملیات موفق`,
            icon: "CheckIcon",
            variant: "success",
            text: `آگهی رد شد.`,
          },
        });
      } catch (error) {
        console.error(error);
      }
      await this.getAd();
    },
    async confirmAd() {
      try {
        const response = await axios.post(
          "https://api.faradidar.com/api/MainFlatTable/ChangeAdsStatus",
          null,
          {
            params: {
              status: 2,
              objectId: this.$route.params.id,
              slug: this.$route.params.slug,
            },
          }
        );
        this.$toast({
          component: ToastificationContent,
          position: "bottom-center",
          props: {
            title: `عملیات موفق`,
            icon: "CheckIcon",
            variant: "success",
            text: `آگهی تایید شد.`,
          },
        });
      } catch (error) {
        console.error(error);
      }
      await this.getAd();
    },
    timeAgo(time) {
      switch (typeof time) {
        case "number":
          break;
        case "string":
          time = +new Date(time);
          break;
        case "object":
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      let time_formats = [
        [60, "ثانیه ", 1], // 60
        [120, "1 دقیقه پیش", "یک دقیقه از الان"], // 60*2
        [3600, "دقیقه ", 60], // 60*60, 60
        [7200, "1 ساعت پیش", "1 ساعت از الان"], // 60*60*2
        [86400, "ساعت ", 3600], // 60*60*24, 60*60
        [172800, "دیروز", "فردا"], // 60*60*24*2
        [604800, "روز ", 86400], // 60*60*24*7, 60*60*24
        [1209600, "هفته پیش", "هفته بعد"], // 60*60*24*7*4*2
        [2419200, "هفته", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "ماه پیش", "ماه بعد"], // 60*60*24*7*4*2
        [29030400, "ماه", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "سال پیش", "سال بعد"], // 60*60*24*7*4*12*2
        [2903040000, "سال", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      ];
      let seconds = (+new Date() - time) / 1000,
        token = "پیش",
        list_choice = 1;

      if (seconds == 0) {
        return "همین حالا";
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "از الان";
        list_choice = 2;
      }
      let i = 0,
        format;
      while ((format = time_formats[i++]))
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      return time;
    },
  },
  computed: {
    adVideo() {
      if (this.adDetails && this.adDetails.medias) {
        let mainVideo = this.adDetails.medias.find(
          (item) => item.priority == 3
        );
        if (mainVideo && mainVideo.base64) {
          return `https://api.faradidar.com/media/gallery/adsmedia/${mainVideo.base64}`;
        }
      }
    },
  },
};
</script>
